const companyPerformanceAdapter = (recruiter) => {
  // This has been updated as requested to only return the start date.
  // const startDate = recruiter.activeSubscription
  //   ? recruiter.activeSubscription.startDate
  //   : recruiter.createdAt;
  const startDate = recruiter.createdAt;

  return {
    engagements: recruiter.recruiterJobMetrics.totalJobs,
    interviewCount: recruiter.recruiterJobMetrics.interviewsConfirmed,
    interviewRate: recruiter.recruiterJobMetrics.applicationsToInterviewPercent,
    memberSince: startDate,
    placements: recruiter.recruiterJobMetrics.placementsMade,
    testimonial: recruiter.hiringHubTestimonial,
  };
};

export default companyPerformanceAdapter;
